import { ChangeDetectionStrategy, Component } from '@angular/core'
import { Action, Store } from '@ngrx/store'
import { routerTransition } from './route-animations'

@Component({
  selector: 'app-card-layout',
  templateUrl: './card-layout.component.html',
  styleUrls: ['./card-layout.component.scss'],
  animations: [routerTransition],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardLayoutComponent {
  constructor(private readonly store: Store) {}

  public onToastButtonClick(action: Action) {
    this.store.dispatch(action)
  }

  public onToastDismiss(action: Action) {
    this.store.dispatch(action)
  }
}
